import { Component, OnInit, ChangeDetectionStrategy, HostListener } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Router, NavigationError, NavigationEnd, NavigationStart } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AntEnvService, AuthService, AbsAuthService, HelperService } from '../_services';
import { AngularFireAuth } from '@angular/fire/auth';
import * as M from "materialize-css/dist/js/materialize";
import { environment } from '../../environments/environment';

import { DataServiceProvider } from 'src/app/_providers';
import { DataService } from '../_services';
import { FcmService } from '../_services/fcm.svc';
let _theme = environment['themeName'];

@Component({
  selector: 'app-nav',
  templateUrl: './app-nav.component.html',
  //styleUrls: ['./app-nav.component.tp.css'],
  styleUrls: ['./app-nav.component.css'],
  //styleUrls: [require('./app-nav.component' + (_theme ? '.' + _theme : '') + '.css')],
  //changeDetection: ChangeDetectionStrategy.OnPush
  providers:[{provide: AbsAuthService, useClass: AuthService}]
})
export class AppNavComponent implements OnInit {

  pageData = {
    menuIndex: 0,
    menus:[]
  };
  sensorR = [];
  sensorG = [];
  sensorY = [];
  sensorO = [];
  isAuthOk: boolean = false;
  showSensorStatus:boolean = false;
  showSensorImage:boolean = false;
  isLoading: boolean = false; routeCurrent = '';
  toggleStores: any = [];
  routePort: any;
  apiUrl: any;
  arrToggleStores: any;
  areaIndex: number;
  constructor(
    private router: Router,
    private http: HttpClient,
    private firebaseAuth: AngularFireAuth,
    private svcAntEnv: AntEnvService,
    private svcAuth: AbsAuthService,
    private svcHelper: HelperService,
    private svcData: DataService,
    private svcFcm: FcmService
  ) { 
    this.svcAuth = DataServiceProvider.useFactory(this.firebaseAuth, this.http, this.svcAntEnv);
  }

  theme(): string[] {
    var _url = '/app-nav.component.css';
    if(_theme){
      var _url = '/app-nav.component.css.' + _theme + '.css';
    }
    //console.log(_url);
    return [_url];
  }

  ngOnInit() {
    this.toggleStores = [];
    this.arrToggleStores = [];
    this.svcHelper.versionCheckStart();
    //console.log('./app-nav.component' + (_theme ? '.' + _theme : '') + '.css');
    this.showSensorImage = environment.sensorImage;
    this.router.events.subscribe(
      (ee: any) => {
        if (ee instanceof NavigationStart) {
          //console.log('Show loading indicator');
        }
        if (ee instanceof NavigationEnd) {
          this.pageData.menus.forEach((m, iM)=>{
            m.active = m.route == this.router.url;
            if(m.active){
              this.pageData.menuIndex = iM;
            }
          });
          this.loginValidate();
          this.routeCurrent = this.router.url;
          //console.log(this.router.url);
        }
        if (ee instanceof NavigationError) {
          //console.log(ee.error);
        }
      }
    );

    var user = JSON.parse(localStorage.getItem("currentUser"));

    this.svcAntEnv.load().subscribe(res=>{
      if(res != null){
          this.apiUrl = res.apiUrl;
      }
    });

    this.svcAntEnv.loadToggleStores().subscribe(res=>{
      if(res != null){
          //console.log(res)
          this.toggleStores = res;
      }

      this.toggleStores.forEach(x=>{
        if(x.isDefault != "1"){
          this.routePort = x.port;
          this.svcData.userListByCustomPort(this.routePort).subscribe(res1 => {
            var _arr = res1.data.filter(u => u.fullName == user.fullName)
            if(_arr.length>0){ 
              this.arrToggleStores.push(x); 
            }
          })
        }
      })

  });
    
  }
  ngAfterViewInit(){
    var elems = document.querySelectorAll('.adl');
    M.Dropdown.init(elems, {});
  }
  dataLoadLastData(){
    if(this.isLoading) return; // skip the redundant call
    
    this.isLoading = true;
    this.sensorG = [];
    this.sensorR = [];
    this.sensorY = [];
    this.sensorO = [];
    this.svcData.isBusinessHour().subscribe(r=>{
      if(r.status != 'OK'){
        this.showAlert(r.message);
        this.isLoading = false;
        this.dataLoadLastDataSetTimer();
        return;
      }
      if(r.data || 1==1){
        this.svcData.sensorDataLastData().subscribe(res=>{
          this.dataLoadLastDataSetTimer();

          this.isLoading = false;
          if(res.status != 'OK'){
            this.showAlert(res.message);
            return;
          }
          res.data.forEach(rec => {
            if(rec.statusColor == 'G') this.sensorG.push(rec);
            else if(rec.statusColor == 'R') this.sensorR.push(rec);
            else if(rec.statusColor == 'Y') this.sensorY.push(rec);
            else if(rec.statusColor == 'O') this.sensorO.push(rec);
          });

          this.sensorG.forEach(rec=>{
            rec.imgUrl = `${this.svcData.apiUrl}/api/sensor/image/${rec.sensor.sensorUuid}`;
          });
          this.sensorR.forEach(rec=>{
            rec.imgUrl = `${this.svcData.apiUrl}/api/sensor/image/${rec.sensor.sensorUuid}`;
          });
          this.sensorY.forEach(rec=>{
            rec.imgUrl = `${this.svcData.apiUrl}/api/sensor/image/${rec.sensor.sensorUuid}`;
          });
          this.sensorO.forEach(rec=>{
            rec.imgUrl = `${this.svcData.apiUrl}/api/sensor/image/${rec.sensor.sensorUuid}`;
          });

          var elems = document.querySelectorAll('.modal');
          M.Modal.init(elems, {});
        });
      }
    });
  }
  dataLoadLastDataSetTimer(){
    setTimeout(()=>{
      this.dataLoadLastData();
    }, 3*60*1000);
  }
  loginValidate(){
    if(environment.apiType == 'FB'){
      this.svcAuth.user.subscribe(x => {
        if(x){
          this.isAuthOk = true;
          //var ps = new PerfectScrollbar('.ps');
        }
        else{
          this.isAuthOk = false;
          this.goto('/login');
        }
      });
    }
    else if(environment.apiType == 'API'){
      var currentAcc = this.svcAuth.getCurrentUser();
      if(currentAcc == null){
        this.logout();
      }
      //else this.isAuthenticated$ = true;
      else{
        this.isAuthOk = true;
        //this.pageData.menus = this.svcHelper.menus(currentAcc);
        
        //console.log('current-acc',currentAcc);
        this.svcHelper.menusInit(currentAcc);
        this.menuListLoad();
      }
    }
    if(this.isAuthOk){
      this.dataLoadLastData();
      window.setTimeout(()=>{
        var elems = document.querySelectorAll('.adl');
        M.Dropdown.init(elems, { constrainWidth: true });
      }, 300);
    }
  }
  menuListLoad(){
    //console.log('menu-list-load');
    setTimeout(()=>{
      this.pageData.menus = this.svcHelper.menuList;
      if(this.pageData.menus.length<1) this.menuListLoad();

      this.pageData.menus.forEach((_m, i)=>{
        switch(this.routeCurrent){
          case '/data-viewer':
            _m.active = _m.title == 'Data Viewer';
            break;
          case '/dashboard':
            _m.active = _m.title == 'Dashboard';
            break;
            case '/dashboardV02A':
            _m.active = _m.title == 'Analytics';
            break;
            case '/dashboardV02AD':
            _m.active = _m.title == 'Analytics';
            break;
            case '/dashboardV02AW':
            _m.active = _m.title == 'Analytics';
            break;
            case '/dashboardV02AM':
            _m.active = _m.title == 'Analytics';
            break;
          case '/data-report':
            _m.active = _m.title == 'Report';
            break;
          case '/settings':
            _m.active = _m.title == 'Settings';
            break;
          case '/users':
            _m.active = _m.title == 'User Mgmt';
            break;
        }
      });
    }, 500);
  }
  menuGroupSelect(arg){
    this.pageData.menus.forEach(m=>{
      //m.active = false;
    });
    arg.active = !arg.active;
  }
  menuItemSelect(argIndex){
    //this.pageData.menuIndex = argIndex;
    if(this.pageData.menus[argIndex].active) return;
    this.pageData.menus.forEach((m, iM)=>{
      m.active = iM == argIndex;
      if(m.active){
        if(m.route == '/logout'){
          this.logout();
        }
        else{
          this.goto(m.route);
        }
      }
    });
  }
  toggleFullScreen() {
    // if(document.fullscreenElement){
    //   document.exitFullscreen();
    // }
    // else{
    //   let elem =  document.body; 
    //   let methodToBeInvoked = elem.requestFullscreen 
    //     || elem.webkitRequestFullScreen || elem['mozRequestFullscreen'] 
    //     || elem['msRequestFullscreen']; 
    //   if(methodToBeInvoked){
    //     methodToBeInvoked.call(elem);
    //   }
    // }
  }
  goto = function(argRout){
    this.router.navigate([argRout]);
  }
  showAlert(msg){
    alert(msg);
    //M.toast({html: msg});
  }
  logout = function() {
    // console.log(this.svcAuth.getCurrentUser());
    var _usr = '';
    if(this.svcAuth.getCurrentUser() != null){
      var user = this.svcAuth.getCurrentUser();
      user.status = 0;
      _usr = user.userId;
      if(localStorage.getItem('fcmToken')){
        this.svcData.deleteToken(localStorage.getItem('fcmToken').toString(), _usr.toString()).subscribe();
      }
      this.svcData.sessionUpdate(user).subscribe();
    }
    
    this.svcAuth.logout();
    
    this.isAuthOk = false;
    this.router.navigate(['/login']);
  }

  toggleSelectDdl(arg){
    console.log(arg);
    var _arr = this.toggleStores.filter(x=>x.name == arg);
    this.routePort = _arr.filter(x => x.uiPort);
    console.log(this.routePort[0].uiPort);
    var arrApiUrlSegment = this.apiUrl.split(':');
        var firstSegment = arrApiUrlSegment[0];
        var secondSegment = arrApiUrlSegment[1];
        var thirdSegment = this.routePort[0].uiPort;
        var newApiUrl = firstSegment+":"+secondSegment+":"+thirdSegment;
        console.log(newApiUrl);
    window.location.href = newApiUrl;
  }

}
